import { BarChart3Icon, FactoryIcon, MagnetIcon, SettingsIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Engineering Fundamentals & Applied Mechanics',
    summary: 'Core principles, engineering mathematics, forces, statics, dynamics, motion, energy, friction, vibrations.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Engineering Materials & Strength of Components',
    summary: 'Material classification, properties, stress/strain, strength, fatigue, wear, corrosion, material selection.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Machine Elements & Mechanical Design',
    summary: 'Design principles, shafts, gears, bearings, fasteners, springs, power transmission, design calculations.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Thermodynamics, Fluid Mechanics & Heat Transfer',
    summary: 'Thermodynamic laws, energy, heat, fluid properties, flow behavior, pumps, heat exchangers, calculations.',
    icon: BarChart3Icon,
  },
  {
    number: '5',
    title: 'Manufacturing Processes & Industrial Production',
    summary: 'Casting, forming, machining, CNC, welding, additive manufacturing, tolerances, quality control.',
    icon: FactoryIcon,
  },
  {
    number: '6',
    title: 'Industrial Machinery, Reliability & Modern Engineering',
    summary: 'Machinery systems, motors, pumps, hydraulics, maintenance strategies, failure analysis, modern technologies.',
    icon: ZapIcon,
  },
];
